import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/api/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (
    req.url.includes('/admin/auth/login') ||
    req.url.includes('/admin/auth/refresh')
  ) {
    return next(req);
  }

  const token = inject(AuthService).token();
  if (!token) return next(req);

  return next(
    req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    }),
  );
};
